import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Star, Quotes } from "@phosphor-icons/react";

export default function Testimonials() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/testimonials").then(({ data }) => setItems(data)).catch(() => {});
  }, []);

  if (!items.length) return null;

  return (
    <section id="testimonials" className="py-24 px-6 bg-[#141414] border-y border-[#27272A]">
      <div className="max-w-7xl mx-auto">
        <p className="font-heading uppercase tracking-[0.2em] text-xs text-[#D4AF37] mb-2">Client Voices</p>
        <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl text-white tracking-tight mb-12">Trusted Across The Bay</h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {items.map((t, i) => (
            <div key={t.id} data-testid={`testimonial-card-${i}`} className="bg-[#0A0A0A] border border-[#27272A] rounded-2xl p-6 flex flex-col">
              <Quotes size={24} weight="fill" className="text-[#D4AF37] mb-3" />
              <p className="text-sm text-[#D4D4D8] leading-relaxed flex-1 mb-4">&ldquo;{t.quote}&rdquo;</p>
              <div className="flex items-center gap-3">
                <img src={t.avatar} alt={t.name} className="w-10 h-10 rounded-full object-cover" />
                <div>
                  <p className="text-sm text-white font-semibold">{t.name}</p>
                  <p className="text-xs text-[#71717A]">{t.role} &middot; {t.location}</p>
                </div>
              </div>
              <div className="flex gap-0.5 mt-3">
                {Array.from({ length: t.rating }).map((_, si) => (
                  <Star key={si} size={14} weight="fill" className="text-[#D4AF37]" />
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
